export default __webpack_public_path__ + "static/assets/ce8ebcc122ee15b4106a38724f06529c.png";